<div class="alerts-page">
  <div class="alerts-header">
    <h2><i class="fa-solid fa-bell"></i>{{ 'AlertsAlerts' | t }}</h2>
    <button
      type="button"
      class="ack-all-button"
      *ngIf="showAckAll"
      data-test="ack-all"
      [disabled]="acknowledging"
      (click)="acknowledgeAll()"
    >
      <i class="fa-solid fa-check-double"></i>
      {{ acknowledging
        ? ('AlertsAcknowledging' | t)
        : isAdmin
          ? ('AlertsAcknowledgeAll' | t)
          : ('AlertsAcknowledgeAllForProject' | t: { project: project }) }}
    </button>
  </div>

  <div class="alerts-tabs">
    <button
      type="button"
      class="alerts-tab"
      *ngFor="let tab of tabs"
      [class.active]="activeTab === tab.key"
      (click)="selectTab(tab.key)"
    >
      {{ tab.label }}
    </button>
  </div>

  <div class="alerts-loading" *ngIf="loading">{{ 'AlertsLoadingAlerts' | t }}</div>

  <div class="alerts-empty" *ngIf="!loading && alerts.length === 0">
    <i class="fa-solid fa-circle-check"></i>
    No {{ activeTab === 'all' ? '' : activeTab }} alerts
  </div>

  <div class="alerts-table-wrap" *ngIf="!loading && alerts.length > 0">
    <table class="alerts-table">
      <thead>
        <tr>
          <th>{{ 'AlertsSeverity' | t }}</th>
          <th>{{ 'AlertsCondition' | t }}</th>
          <th>{{ 'PDFReport_InfoBlockBase_ProjectInformation' | t }}</th>
          <th>{{ 'AlertsDevice' | t }}</th>
          <th>{{ 'AlertsMessage' | t }}</th>
          <th>{{ 'AlertsFirstSeen' | t }}</th>
          <th>{{ 'AlertsLastSeen' | t }}</th>
          <th>{{ 'AlertsCount' | t }}</th>
          <th>{{ 'AlertsState' | t }}</th>
          <th>{{ 'AlertsAcknowledged' | t }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
            *ngFor="let alert of alerts"
            [class.alert-row-clickable]="canOpenAlert(alert)"
            [attr.tabindex]="canOpenAlert(alert) ? 0 : null"
            [attr.title]="canOpenAlert(alert) ? 'Open ' + alert.projectName : null"
            (click)="openAlertProject(alert)"
            (keydown.enter)="openAlertProject(alert)">
          <td>
            <span class="severity-pill sev-{{ alert.severity }}">{{ alert.severity }}</span>
          </td>
          <td>{{ conditionLabel(alert) }}</td>
          <td class="cell-project">{{ alert.projectName }}</td>
          <td>{{ alert.deviceSerial }}</td>
          <td class="cell-message">{{ alert.message }}</td>
          <td class="cell-time">{{ alert.firstSeenAt | vcDate: 'seconds' }}</td>
          <td class="cell-time">{{ alert.lastSeenAt | vcDate: 'seconds' }}</td>
          <td class="cell-count">{{ alert.occurrences }}</td>
          <td>
            <span class="state-pill state-{{ alert.state }}">
              {{ alert.state }}{{ alert.state === 'resolved' && alert.autoResolved ? ' (auto)' : '' }}
            </span>
          </td>
          <td class="cell-ackby">
            <ng-container *ngIf="alert.acknowledgedBy">
              {{ (alert.acknowledgedBy.name ? { name: alert.acknowledgedBy.name, username: alert.acknowledgedBy.email } : null) | actor: alert.acknowledgedBy.email }}<br />
              <span class="cell-time">{{ alert.acknowledgedAt | vcDate: 'minutes' }}</span>
            </ng-container>
          </td>
          <td>
            <button
              type="button"
              class="ack-button"
              *ngIf="alert.state === 'open'"
              (click)="acknowledge(alert); $event.stopPropagation()"
            >{{ 'AlertsAck' | t }}</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
